<template>
  <div>
    <b-card class="border-0">
      <StoreList :data="storeList.data"></StoreList>
    </b-card>
  </div>

</template>

<script>
  import StoreList from '@/expertoRetail/atoms/ExpertoRetailMobileStoreList'
  export default {
    name: 'mobile',
    props: [],
    components: {
      StoreList
    },
    data () {
      return {
        textFilter: '',
        storeList: {
          data: []
        }
      }
    },
    methods: {
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/organisms/ExpertoRetailMobileDashboard.vue